import * as brandColors from '../../../utils/brand-colors';

export default () => ({
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  chevron: { color: brandColors.grey[300] },
  accentColor: { color: brandColors.grey.main },
});
